<div class="grid-column-preferences">
  <!-- <button
    class="button button--primary"
    type="button"
    (click)="openColumnOrder()"
    matTooltip="Set Column Order"
    matTooltipPosition="above"
  >
    <span class="button__text"> Set Column Order </span>
  </button> -->
  <button mat-icon-button (click)="openColumnOrder()" matTooltip="Set Column Order"
    matTooltipPosition="above" class="sort-icon">
                <mat-icon class="warn">sort</mat-icon></button>

  <div class="show-hide-container">
    <mat-label class="column-label">  {{ "Display Columns for" | translate | async }}:  </mat-label>

    <mat-form-field class="display-column-dropdown">
      <mat-select 
        color="warn"
        multiple
        [(ngModel)]="selectedColumns"
        (selectionChange)="selectionChanged()"
      >
        <mat-select-trigger> {{'Show / Hide Columns' | translate | async}} </mat-select-trigger>

        <mat-option *ngFor="let column of columns" [value]="column.GridId">
          {{ column.ColumnDisplayName }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>
